import WorkIm from '../assets/projects/project1.png'
import RealEst from '../assets/projects/project2.png'
import Pblog from '../assets/projects/project3.png'
import Pjob from '../assets/projects/project4.png'
import PEcom from '../assets/projects/project5.png'
export const data = [
  {
    id: 1,
    name: 'Next Ecommers',
    image: PEcom,
    github: '',
    live: 'https://sanbercode-nextjs-batch-41.vercel.app/',
  },
  {
    id: 2,
    name: 'React JS Movie List',
    image: WorkIm,
    github: '',
    live: 'https://lanmovie.netlify.app/',
  },
  {
    id: 3,
    name: 'Vue JS Food list',
    image: RealEst,
    github: '',
    live: 'https://vuejs-kuliner.netlify.app/',
  },
  {
    id: 4,
    name: 'React JS Blog',
    image: Pblog,
    github: '',
    live: 'https://lan-blog2.netlify.app/',
  },
  {
    id: 5,
    name: 'React JS JOB List',
    image: Pjob,
    github: '',
    live: 'https://landingpage-job.netlify.app/',
  },
]
